import { render, staticRenderFns } from "./PrivacyPolicy.vue?vue&type=template&id=552bccce&scoped=true"
import script from "./PrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicy.vue?vue&type=script&lang=js"
import style0 from "./PrivacyPolicy.vue?vue&type=style&index=0&id=552bccce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552bccce",
  null
  
)

export default component.exports